import { Action } from '@ngrx/store';
import {OrderHistory, OrderHistoryParams, PurchaseOtp} from '../purchase.model';

export enum PurchaseActionTypes {
  GET_PURCHASE = '[Purchase] GET_PURCHASE',
  GET_PURCHASE_SUCCESS = '[Purchase] GET_PURCHASE_SUCCESS',
  GET_PURCHASE_FAIL = '[Purchase] GET_PURCHASE_FAIL',
  GET_PURCHASE_OTP = '[Purchase] GET_PURCHASE_OTP',
  GET_PURCHASE_OTP_SUCCESS = '[Purchase] GET_PURCHASE_OTP_SUCCESS',
  GET_PURCHASE_OTP_FAIL = '[Purchase] GET_PURCHASE_OTP_FAIL',
  GetPayPalAgreementApprovalUrl = '[Purchase] Get PayPal Agreement Approval Url',
  GetPayPalAgreementApprovalUrlSuccess = '[Purchase] Get PayPal Agreement Approval Url Success',
  GetPayPalAgreementApprovalUrlFailure = '[Purchase] Get PayPal Agreement Approval Url Failure',
  ResetPayPalAgreementApprovalUrl = '[Purchase] Reset PayPal Agreement Approval Url'
}

export class GetPurchaseAction implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE;
  constructor(public payload: OrderHistoryParams) {}
}

export class GetPurchaseSuccessAction implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_SUCCESS;

  constructor(public payload: OrderHistory[] = null) {}
}

export class GetPurchaseFailAction  implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_FAIL;

  constructor(public payload: any = null) {
  }
}

export class GetPurchaseOtpAction implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_OTP;
  constructor(public payload: any = null) {}
}

export class GetPurchaseOtpSuccessAction implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_OTP_SUCCESS;
  constructor(public payload: PurchaseOtp) {}
}

export class GetPurchaseOtpFailAction implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_OTP_FAIL;
  constructor(public payload: any = null) {}
}

export class GetPayPalAgreementApprovalUrlAction implements Action {
  readonly type = PurchaseActionTypes.GetPayPalAgreementApprovalUrl;

  constructor(public payload: any = null) {}
}

export class GetPayPalAgreementApprovalUrlSuccess implements Action {
  readonly type = PurchaseActionTypes.GetPayPalAgreementApprovalUrlSuccess;

  constructor(public payload: { approval_url: string }) {}
}

export class GetPayPalAgreementApprovalUrlFailure implements Action {
  readonly type = PurchaseActionTypes.GetPayPalAgreementApprovalUrlFailure;

  constructor(public payload: any) {}
}

export class ResetPayPalAgreementApprovalUrlAction implements Action {
  readonly type = PurchaseActionTypes.ResetPayPalAgreementApprovalUrl;

  constructor(public payload: any = null) {}
}


export type PurchaseActions = GetPurchaseAction
  | GetPurchaseSuccessAction
  | GetPurchaseFailAction
  | GetPurchaseOtpAction
  | GetPurchaseOtpSuccessAction
  | GetPurchaseOtpFailAction
  | GetPayPalAgreementApprovalUrlAction
  | GetPayPalAgreementApprovalUrlSuccess
  | GetPayPalAgreementApprovalUrlFailure
  | ResetPayPalAgreementApprovalUrlAction;
